import {LoadingSwitcher} from '@hconnect/uikit'
import {spawnErrorToast} from '@hm/fundamental'
import React, {useCallback, FC} from 'react'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../consts'
import {useDocumentCreate} from '../../hooks/api/useDocumentCreate'
import {useTrackDocumentsAnalytics} from '../../hooks/useTrackDocumentsAnalytics'
import {DocumentUpdate} from '../../types/documents.types'

import {DocumentFormContainer} from './DocumentFormContainer'

type DocumentCreateProps = {
  plantId: string
  country: string
  doClose: () => void
  onSuccessSubmit: (documentId: string) => void
}

export const DocumentCreate: FC<DocumentCreateProps> = ({
  plantId,
  country,
  onSuccessSubmit,
  doClose
}) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const trackAnalyticsEvent = useTrackDocumentsAnalytics({plantId, country})

  const createAction = useDocumentCreate({
    plantId,
    options: {
      onSuccess: ({id}) => {
        onSuccessSubmit(id)
        trackAnalyticsEvent('userAddsInstruction', {instructionId: id})
      },
      onError: () => {
        spawnErrorToast(t('error.failedToUploadFile'))
      }
    }
  })

  const doSubmit = useCallback(
    (item: DocumentUpdate) => {
      createAction.mutate(item)
    },
    [createAction]
  )

  return (
    <LoadingSwitcher isLoading={createAction.isPending}>
      <DocumentFormContainer plantId={plantId} doClose={doClose} doSubmit={doSubmit} />
    </LoadingSwitcher>
  )
}
